module.exports = __webpack_public_path__ + "img/wx-agreement.763c8c12.png";